<template>
  <div class="modal-open">
    <div class="modal modal-opened" tabindex="-1" role="dialog" aria-hidden="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal-rounded">
          <div class="row">
            <div class="col-md-12 text-center" v-if="submitted">
              <p class="congrats_message">
                {{'reset_password.forms.reset_password.congrats.first_line' | trans}}
                <br>
                {{'reset_password.forms.reset_password.congrats.second_line' | trans}}
              </p>
            </div>
            <div class="col-md-12" v-if="!submitted">
              <form enctype="multipart/form-data" novalidate>
                <div class="modal-header">
                  <h2 class="modal-title">{{'reset_password.forms.reset_password.header' | trans}}
                    <span>{{'reset_password.forms.reset_password.sub_header' | trans}}</span>
                  </h2>
                </div>
                <div class="modal-body">
                  <div class="alert alert-danger" role="alert" v-if="errors.has('server')">
                    {{errors.first('server')}}
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <mdc-textfield v-model="user.username"
                                     :label="'validation.attributes.username' | trans"
                                     type="text" name="username"
                                     :class="{'is-invalid': errors.has('username')  || responseHashError}"
                                     v-validate="'required|min:5|max:255'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'validation.attributes.username' | trans"/>
                      <span class="invalid-feedback" v-if="errors.has('username')">
                          {{ errors.first('username') }}
                      </span>
                      <span class="invalid-feedback"
                            :class="{'d-block': responseHashError}"
                            v-if="responseHashError && !errors.has('username')">
                          <strong>{{ responseHashError }}</strong>
                      </span>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-md-12">

                      <mdc-textfield v-model="user.password"
                                     :label="'validation.attributes.password' | trans"
                                     type="password" name="password"
                                     :class="{'is-invalid': errors.has('password')}"
                                     v-validate="'required|min:8|max:16|confirmed'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'validation.attributes.password' | trans"/>
                      <small class="form-text text-muted">{{'passwords.password_subscription' | trans}}</small>
                      <span class="invalid-feedback" v-if="errors.has('password')">
                                            {{ errors.first('password') }}
                                        </span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <mdc-textfield v-model="user.password_confirmation"
                                     :label="'validation.attributes.password_confirmation' | trans"
                                     type="password" name="password_confirmation"
                                     :class="{'is-invalid': errors.has('password_confirmation')}"
                                     v-validate="'required|min:8|max:16'"
                                     data-vv-validate-on="none"
                                     :data-vv-as="'validation.attributes.password_confirmation' | trans"/>
                      <span class="invalid-feedback" v-if="errors.has('password_confirmation')">
                          {{ errors.first('password') }}
                      </span>
                    </div>
                  </div>

                </div>

                <div class="modal-footer">
                  <button type="submit" class="btn btn-success active" @click.prevent="register()"
                          :disabled="disabled">
                    {{'reset_password.forms.reset_password.buttons.reset' | trans}}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  import merge from 'lodash/merge';
  import isObject from 'lodash/isObject';
  import lang from '../../../lang/translator';
  import axios from 'axios';

  export default {
    props: {
      'token': {
        required: true,
        type: String,
      },
    },
    metaInfo: {
      title: lang.get('login.labels.forgot'),
    },
    data() {
      return {
        user: {
          username: null,
          password: null,
          password_confirmation: null,
        },
        disabled: false,
        submitted: false,
        responseHashError: null,
      };
    },
    methods: {
      register: async function () {
        this.disabled = true;
        this.errors.remove('server');
        let result = await
        this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }

        let isSaved = await axios.post('/auth/password/reset', merge(this.user, {token: this.token})).then(response => {
          this.responseHashError = null;
          this.submitted = true;
        }).catch(error => {
          this.responseHashError = error.data.errors.username ? error.data.errors.username.message : error.data.errors.message;
          this.disabled = false;
        })
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/passwordRecovery/components/ResetPasswordForm.vue